import React from 'react'
import { Link } from 'react-router-dom'

const TrainerModal = ({setShowLogoutModal}) => {
  return (
    <div className="absolute top-16 right-20 bg-white rounded-lg shadow border z-10 whitespace-nowrap overflow-hidden">
      <Link to={`/mira-formateur/profile`}>
        <div className="text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center">
        Tableau de bord
        </div>
      </Link>
      <hr />
      <Link to={`/mira-formateur/formation/nouveau`}>
        <div className="text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center">
        Publier une formation
        </div>
      </Link>
      <Link to={`/mira-formateur/formation`}>
        <div className="text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center">
        Inscription
        </div>
      </Link>
      <Link to={`/mira-formateur/etudiant`}>
        <div className="text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center">
        Etudiants
        </div>
      </Link>
      <Link to={`/mira-formateur/abonnement`}>
        <div className="text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center">
        Abonnement
        </div>
      </Link>
    <hr/>
    <button
    onClick={()=>setShowLogoutModal(true)}
      className="w-full text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center"
    >
      Se déconnecter
    </button>
  </div>
  )
}

export default TrainerModal